export default function removeLeadingHashSymbol (hash) {
  if (!hash) {
    return ""
  }
  return hash.replace(/^#/, "")
}
